<template>
  <v-container
    fluid
    fill-height
    dark
    class="message-container animated fadeInDown">
    <v-layout
      align-content-center
      text-center
      row>
      <v-flex xs12>
        <h1 class="text-h1 message-title">503</h1>
      </v-flex>
      <v-flex xs12>
        <h3 class="text-h5 font-weight-bold message-title">{{ $t("errors.network.503.type") }}</h3>
      </v-flex>
      <v-flex xs12>
        <h2 class="text-h6 message-title">{{ $t("errors.network.503.desc") }}</h2>
      </v-flex>
      <v-flex xs12>
        <p class="message-instruction">
          {{ $t("errors.network.503.instructions") }}
        </p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "Error503Module"
  , head: {
    title: function () {
      return {
        inner: this.$t("errors.network.503.type")
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , created() {
    setTimeout(() => this.$router.push({ name: "SignIn" }), 4000);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.message-container {
  background-color: #2f4050;
}
.message-title {
  margin-bottom: 10px;
  color: white;
}
.message-instruction {
  margin-bottom: 30px;
  color: #c4c4c4;
}
</style>



// WEBPACK FOOTER //
// src/views/error/503.vue